import {
  Button,
  Col,
  Form,
  Modal,
  notification,
  Input,
  Row,
  Popover,
  Switch,
  Checkbox,
  message,
  Table,
  Space,
  Dropdown,
  Menu,
} from 'antd'
import moment from 'moment'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { EditableList } from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import styles from './ChainPutstortList.module.css'
import { ExportOutlined, PrintOutlined } from '../../compnents/icons/Icons'
import { DetailQuery } from './Query'
import { DeliveryItem } from '../delivery/deliverySlice'
import {
  DetailCGColumns,
  DetailCGTHColumns,
  DetailLSTHColumns,
  DetailSLColumns,
  DetailYSYWColumns,
  PiCiColumns,
  SearchColumns,
} from './columns'
import { newData } from './newData'
import TextArea from 'antd/lib/input/TextArea'
import {
  selectChainId,
  selectChainName,
  selectChainType,
  selectShortName,
  selectTenantId,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../../app/applicationSlice'
import {
  getAcceptanceApproveAsync,
  getAcceptanceDetailListAsync,
  getAcceptanceDetailMainRemarkSubmitAsync,
  getAcceptanceDetailMainSubmitAsync,
  getAcceptanceDetailSubmitAsync,
  getApprovedFn,
  getCalcStockByApplyReceiptsFn,
  getExportExcelAsync,
  getExportExcelCGMX,
  getInsertInptPoFn,
  getPurchaseBusinessApprovedFn,
  getPurchaseBusinessListFn,
  getPurchaseBusinessRejectedFn,
  getPurchaseBusinessReviewFn,
  getPutstorageDetailFn,
  getRemoveAcceptanceItemAsync,
  getReturnApprovedFn,
  getReturnDeliveryFn,
  getReturnItemPageFn,
  getReturnReceiptFn,
  getReturnRejectedFn,
  getReturnReviewRejectedFn,
  getReviewRejectedFn,
  getSelectChainStockOutItemFn,
  getStoredetailRemoveFn,
  getSubmitForReviewFn,
  getYDExportExcelAsync,
  getYDExportExcelFBAsync,
  insertInptPktFn,
  queryInboundDAsync,
  queryInboundOperateInventoryFn,
} from './chainSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { stordetailBody } from '../../services/storedetail'
import {
  Removestoredetail,
  saveStoreDetailAsync,
  saveStoreDetailInvoiceNbAsync,
} from '../putstorelist/putstorelistSlice'
import {
  detailPutstorage,
  updataPutstorage2,
} from '../putstorage/putstorageSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Category } from '../../models/category'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import {
  LSCGYWprintBody,
  LSTBCKprintBody,
} from '../../models/putstorelistPrint'
import { CopyModal } from './CopyModal'
import { AcceptanceModal } from './AcceptanceModal'
import { StorageModal } from './StorageModal'
import { CopyCGYWModal } from './CopyCGYWModal'
import { PrintTemplateModal } from '../print/PrintTemplateModal'
import { PrintTemplateCategory } from '../../models/print'
import { sum } from 'lodash'

export const ChainPutstortList = (props: {
  category?: string
  selectId?: number
  detail?: any
}) => {
  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const tenantName = useSelector(selectTenantName)

  const userName = useSelector(selectUserName)

  const shortName = useSelector(selectShortName)

  const chainName = useSelector(selectChainName)

  const [messageApi, contextHolder] = message.useMessage()

  const categoryTag = props?.category || location.state?.category

  const selectIdTag = props?.selectId || location.state?.selectId

  const dataDetail: any = props?.detail || location.state?.detail

  const userId = useSelector(selectUserId)

  const [data, setData] = useState<any>([])

  const [form] = Form.useForm()

  const [formRefuse] = Form.useForm()

  const [detail, setDetail] = useState<any>({})

  const [pageLoading, setPageLoading] = useState(false)

  const [piCiVisible, setPiCiVisible] = useState(false)

  const [piCiData, setPiCiData] = useState<any>([])

  const [refuseVisible, setRefuseVisible] = useState(false)

  const [actionType, setActionType] = useState('')

  const [totalCount, setTotalCount] = useState<number>(0)

  const [acceptanceVisible, setAcceptanceVisible] = useState(false)

  const [storageVisible, setStorageVisible] = useState(false)

  const history = useHistory()

  const [searchVisible, setSearchVisible] = useState(false)

  const [copyIsModalVisible, setCopyIsModalVisible] = useState(false)

  const [copyIsCGYWModalVisible, setCopyIsCGYWModalVisible] = useState(false)

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [searchParams, setSearchParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [searchPage, setSearchPage] = useState<any>({ items: [], total: 0 })

  const tableHeight: any =
    document.documentElement.clientHeight || document.body.clientHeight

  const [scrollHeight, setScrollHeight] = useState(tableHeight - 520)

  window.onresize = function () {
    const scrollHeigth: any = tableHeight - 520
    setScrollHeight(scrollHeigth)
  }

  const handleChange = (prev: any, next: any) => {

    if (categoryTag != 1) {
      if (prev.name && next.name && prev.name != next.name) return //防止名称乱改
    }
    // 未开启数据同步的药
    const datas = {
      ...prev,
      ...next,
      productDate: next.productDate
      ? moment(next.productDate).format(DateTimeFormat)
      : moment(prev.productDate).format(DateTimeFormat),
      deadline: next.deadline
      ? moment(next.deadline)
          .endOf('day')
          .format(DateTimeFormat)
      : moment(prev.deadline)
          .endOf('day')
          .format(DateTimeFormat),
      // invoiceNb: next.invoiceNb ? next.invoiceNb : prev.invoiceNb,
      stockCount: next.count ? next.count : prev.count,
      productInfo:
        next?.spec ||
        next.packSpec ||
        next.accountUnit ||
        next.doseCategory ||
        next.tenantSupplierName
          ? ` ${next?.spec} /${next.packSpec} /${next.accountUnit} /${next.doseCategory} /${next.tenantSupplierName}`
          : `${prev.productInfo}`,
      id: prev.id,
      lastInstockPrice:
        next?.lastInstockPrice > 0 ? next?.lastInstockPrice : next?.retailPrice,
    }
    const newdata = datas

    setData(data.map((v: any) => (v.id === newdata.id ? newdata : { ...v })))
  }

  const handleSave = (obj: stordetailBody) => {
    // if (obj.tempName != obj.name) {   //防止乱改药品名称
    //   notification.info({
    //     message: '请重新选择药品！'
    //   })
    //   return
    // }
    if (obj.id) {
      //修改单据
      setPageLoading(true)
      dispatch(saveStoreDetailAsync(obj))
        .then(unwrapResult)
        .then(() => {
          // dispatch(detailPutstorage(selectIdTag))  //获取详情
          dispatch(
            updataPutstorage2({
              ...detail,
            })
          )
            .then(() => {
              //获取详情
              setPageLoading(false)
              getData()
            })
            .then(() => {
              messageApi.open({
                type: 'success',
                content: '保存成功',
                className: 'custom-class',
              })
            })
        })
        .catch(() => {
          setPageLoading(false)
          // notification.error({
          //   message: "添加药品失败,请检查",
          // });
        })
    } else {
      setPageLoading(true)
      //保存单据
      dispatch(saveStoreDetailAsync(obj))
        .then(unwrapResult)
        .then(() => {
          dispatch(
            updataPutstorage2({
              ...detail,
            })
          )
            .then(() => {
              //获取详情
              setPageLoading(false)
              getData()
            })
            .then(() => {
              messageApi.open({
                type: 'success',
                content: '保存成功',
                className: 'custom-class',
              })
            })
        })
        .catch(() => {
          setPageLoading(false)
          // notification.error({
          //   message: "添加药品失败,请检查",
          // })
        })
    }
  }

  const handleSubmit = (obj: any) => {
      setPageLoading(true)
      dispatch(getAcceptanceDetailSubmitAsync({
        ...obj,
        inventoryPurchaseAcceptanceId: dataDetail?.id,
        supplierId: dataDetail?.supplierId,
        supplierName: dataDetail?.supplierName,
        arrivalOrderNumber: dataDetail?.arrivalOrderNumber,
      }))
      .then(unwrapResult)
      .then(() => {
        setPageLoading(false)
        getData()
        messageApi.open({
          type: 'success',
          content: '保存成功',
          className: 'custom-class',
        })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  const getData = () => {
    if (
      categoryTag == Category.CGYW ||
      categoryTag == Category.CGTHYW ||
      categoryTag == Category.FDTHYW ||
      categoryTag == Category.ZDTHYW
    ) {
      dispatch(getPutstorageDetailFn(Number(selectIdTag)))
        .then(unwrapResult)
        .then((v: any) => {
          setDetail({
            ...v?.inventoryReceipts,
            storehouseCategory: categoryTag,
          })
          setData(
            v?.outInvReceiptsItemList?.map((v: any) => {
              return {
                ...v,
                stockPrice: v?.stockPrice != -1 &&  v?.stockPrice,
                unitPrice: v?.unitPrice != -1 &&  v?.unitPrice,
              }
            })
          )
        })
    } else if(categoryTag == Category.YSYW) {
      dispatch(getAcceptanceDetailListAsync({id: dataDetail?.id}))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res)
      })
    } else {
      if (tenantId == chainId) {
        setDetail(location.state?.detail)
        if (dataDetail?.storehouseTag != '201') {
          dispatch(
            getSelectChainStockOutItemFn({
              businessType: 1,
              inventoryReceiptsId: selectIdTag,
            })
          )
            .then(unwrapResult)
            .then((res: any) => {
              setData(res)
            })
        } else {
          dispatch(getCalcStockByApplyReceiptsFn(selectIdTag))
            .then(unwrapResult)
            .then((res: any) => {
              setData(res)
            })
        }
      } else {
        dispatch(getPutstorageDetailFn(Number(selectIdTag)))
          .then(unwrapResult)
          .then((v: any) => {
            setDetail({
              ...v?.inventoryReceipts,
              storehouseCategory: categoryTag,
            })
            if (
              dataDetail?.storehouseTag == '200' ||
              dataDetail?.storehouseTag == '201'
            ) {
              setData(v?.outInvReceiptsItemList)
            } else {
              dispatch(
                getSelectChainStockOutItemFn({
                  businessType: 0,
                  inventoryReceiptsId: dataDetail?.acceptId,
                  acceptTenantId: dataDetail?.acceptTenantId,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  setData(res)
                })
            }
          })
      }
    }
  }

  useEffect(() => {
    if (selectIdTag) {
      getData()
    }
  }, [selectIdTag])

  useEffect(() => {
    if (!data?.length) {
      if (detail?.storehouseTag == 200 && tenantId != chainId) {
        setData([...data, newData])
      }
      if (detail?.storehouseTag == 206) {
        setData([...data, newData])
      }
      if (dataDetail?.approvedState == 0) {
        setData([...data, newData])
      }
    }
    if (data.every((v: any) => v.id)) {
      if (detail?.storehouseTag == 200 && tenantId != chainId) {
        setData([...data, newData])
      }
      if (detail?.storehouseTag == 206) {
        setData([...data, newData])
      }
      if (dataDetail?.approvedState == 0) {
        setData([...data, newData])
      }
    }
  }, [data])

  useEffect(() => {
    setTotalCount(
      piCiData?.batchs?.reduce(
        (acc: number, item: any) => acc + Number(item.count),
        0
      )
    )
  }, [piCiData])

  useEffect(() => {
    form.setFieldsValue({
      remark: dataDetail?.remark,
    })
  }, [dataDetail])

  const dataMainList = {
    tenantName: tenantName?.split('-')?.[0],
    userName: userName,
    shortName: shortName,
    chainId: chainId,
    tenantId: tenantId,
    detail: {
      ...dataDetail,
      sqmd: tenantId == chainId ? detail?.source : shortName,
      stockPriceTotal: sum(data?.map((t:any)=>t.stockPrice && detail?.storehouseTag > 200  ? t.stockPrice : 0))
    },
    dataList: data?.map((v: any) => {
      return {
        ...v,
        stockPrice:
          v.stockPrice && detail?.storehouseTag > 200 ? v.stockPrice : '-',
        stockCount: v.stockCount || '-',
        slCount:
          tenantId == chainId
            ? v?.needCount
            : detail?.storehouseTag > 201
            ? v?.needCount
            : v?.count,
      }
    }),
  }

  const content = LSTBCKprintBody(dataMainList)

  const dataMainLists = {
    tenantName: tenantName?.split('-')?.[0],
    userName: userName,
    detail: {
      ...detail,
      approvedUserName:location?.state?.approvedUserName ?location?.state?.approvedUserName :'',
      approvedTime: detail?.approvedTime
        ? moment(detail?.approvedTime).format(DateTimeFormatSimpleOnlyOne)
        : '',
    },
    dataList: data
      ?.filter((n: any) => n?.id)
      ?.map((v: any) => {
        return {
          ...v,
          totalPrice: v.totalPrice ? v.totalPrice?.toFixed(2) : '-',
          cgPrice: v.stockPrice
            ? parseFloat(v.stockPrice).toFixed(5)
            : v.unitPrice
            ? parseFloat(v.unitPrice).toFixed(5)
            : '',
          genericName: Number(v.genericName) !== 0 ? v.genericName : '',
          productInfo: v?.productInfo ? (
            v?.productInfo
          ) : v.spec ||
            v.packSpec ||
            v.accountUnit ||
            v.doseCategory ||
            v.tenantSupplierName ? (
            v.spec +
            '/' +
            v.packSpec +
            '/' +
            v.accountUnit +
            '/' +
            v.doseCategory +
            '/' +
            v.tenantSupplierName
          ) : (
            <></>
          ),
        }
      }),
  }

  const contentCGYW = LSCGYWprintBody(dataMainLists)

  // 导出总部
  const exportExcel = () => {
    dispatch(
      getYDExportExcelAsync({
        businessType: 1,
        inventoryReceiptsId: selectIdTag,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = location.state?.backtrace?.name + '.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
        })
      })
      .catch((res: any) => {
        return
      })
  }

  // 导出分部
  const exportExcelFB = () => {
    const getMessage: any =
      detail?.storehouseTag == 203 ||
      detail?.storehouseTag == 204 ||
      detail?.storehouseTag == 205
        ? getYDExportExcelAsync
        : getYDExportExcelFBAsync

    const params =
      detail?.storehouseTag == 203 ||
      detail?.storehouseTag == 204 ||
      detail?.storehouseTag == 205
        ? {
            businessType: tenantId == chainId ? 1 : 0,
            inventoryReceiptsId: dataDetail?.acceptId,
            acceptTenantId: dataDetail?.acceptTenantId,
          }
        : { tenantInventoryReceiptsId: selectIdTag }
    dispatch(getMessage({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = location.state?.backtrace?.name + '.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
        })
      })
      .catch((res: any) => {
        return
      })
  }

  // 采购明细导出
  const exportExcelCGMX = () => {
    dispatch(getExportExcelCGMX({ tenantInventoryReceiptsId: selectIdTag }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '采购业务.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
        })
      })
      .catch((res: any) => {
        return
      })
  }

  
  const menu = () => (
    <Menu
      // onClick={(item) => {
      //   onItemChange && onItemChange(Number(item.key), v)
      // }}
    >
      <Menu.Item key='1'
        onClick={() => {
          const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
          page.document.write(content) // 写入打印页面的内容
          page.print() // 打印
          page?.close()
        }}
      >
        调拨单
      </Menu.Item>
      <Menu.Item key='2'
        onClick={() => {
          setIsPrintModalVisible(true)
        }}
      >
        随货同行单
      </Menu.Item>
    </Menu>
  )

  console.log(categoryTag,"categoryTag");

  return (
    <>
      {contextHolder}
      <div className={styles.putStorage}>
        {!props?.selectId ? (
          <NavBar
            style={{ margin: '0px 20px' }}
            where={location.state?.where}
            backtrace={{
              name: location.state?.name,
              path: location.state?.path,
              routeName: categoryTag == Category.YSYW 
              || (categoryTag == Category.CGYW && dataDetail?.type == 2) 
              ? '库房工作站' : location.state?.backName,
            }}
            buttons={
              categoryTag == Category.CGYW ||
              categoryTag == Category.SLYW ||
              categoryTag == Category.LSDBCK ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  {tenantId == chainId ? (
                    detail?.storehouseTag != '201' && (
                      <Button
                        style={{
                          border: 'none',
                          background: '#FFFFFF',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={() => {
                          if (categoryTag == Category.CGYW) {
                            // 采购明细导出
                            exportExcelCGMX()
                          } else {
                            exportExcel()
                          }
                        }}
                      >
                        <ExportOutlined
                          style={{
                            fill: '#666',
                            width: '14px',
                            height: '14px',
                            marginRight: '8px',
                          }}
                        />
                        导出
                      </Button>
                    )
                  ) : (
                    <Button
                      style={{
                        border: 'none',
                        background: '#FFFFFF',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        if (categoryTag == Category.CGYW) {
                          // 采购明细导出
                          exportExcelCGMX()
                        } else {
                          exportExcelFB()
                        }
                      }}
                    >
                      <ExportOutlined
                        style={{
                          fill: '#666',
                          width: '14px',
                          height: '14px',
                          marginRight: '8px',
                        }}
                      />
                      导出
                    </Button>
                  )}
                  {categoryTag == Category.LSDBCK ? 
                    <>
                    <Dropdown overlay={menu()} placement='bottomRight' trigger={['click']}>
                      <Button
                        style={{
                          border: 'none',
                          background: '#FFFFFF',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        size='small'
                        // onClick={() => {
                        //   const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
                        //   page.document.write(content) // 写入打印页面的内容
                        //   page.print() // 打印
                        //   page?.close()
                        // }}
                      >
                        <PrintOutlined
                          style={{
                            fill: '#666',
                            width: '18px',
                            height: '18px',
                            marginRight: '8px',
                          }}
                        />
                        打印
                      </Button>
                      </Dropdown>
                    </>
                  : 
                    <>
                      <Button
                        style={{
                          border: 'none',
                          background: '#FFFFFF',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        size='small'
                        onClick={() => {
                          if (categoryTag == Category.CGYW) {
                            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
                            page.document.write(contentCGYW) // 写入打印页面的内容
                            page.print() // 打印
                            page?.close()
                          } else {
                            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
                            page.document.write(content) // 写入打印页面的内容
                            page.print() // 打印
                            page?.close()
                          }
                        }}
                      >
                        <PrintOutlined
                          style={{
                            fill: '#666',
                            width: '18px',
                            height: '18px',
                            marginRight: '8px',
                          }}
                        />
                        打印
                      </Button>
                    </>
                  }
                </div>
              ) : (
                <></>
              )
            }
          />
        ) : (
          <></>
        )}
        <div className={styles.content}>
          <DetailQuery
            category={categoryTag}
            Detail={dataDetail}
            selectId={selectIdTag}
            onRefuse={() => {
              setRefuseVisible(true)
            }}
            print={() => {
              const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
              page.document.write(content) // 写入打印页面的内容
              page.print() // 打印
              page?.close()
            }}
            onOK={() => {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                content: (
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;是否确认通过？
                  </div>
                ),
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onOk: () => {
                  dispatch(
                    categoryTag == Category.CGYW ||
                      categoryTag == Category.CGTHYW
                      ? getPurchaseBusinessApprovedFn(selectIdTag)
                      : categoryTag == Category.ZDTHYW
                      ? getReturnApprovedFn(selectIdTag)
                      : categoryTag == Category.YSYW
                      ? getAcceptanceApproveAsync({ 
                        type: 1, 
                        id: dataDetail?.id,
                        arrivalOrderNumber: dataDetail?.arrivalOrderNumber,
                        supplierId: dataDetail?.supplierId,
                        supplierName: dataDetail?.supplierName,
                      })
                      : getApprovedFn({
                          approveUserId: userId,
                          subInventoryReceiptsId: selectIdTag,
                          details: data,
                        })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '操作成功',
                      })
                      history.push({
                        pathname: categoryTag == Category.YSYW ? '/acceptanceBusiness' : dataDetail?.type == 2 ? '/procorementBusiness' :  '/chainTransferOutbound',
                      })
                    })
                },
              })
            }}
            onSubmit={() => {
              const flag = data?.filter((v: any) => v.id)?.length
              if (flag) {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认
                      {categoryTag == Category.FDTHYW
                        ? '退货提交'
                        : categoryTag == Category.CGYW
                        ? '采购提交'
                        : categoryTag == Category.YSYW
                        ? '验收提交'
                        : '申领提交'}
                      ？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    dispatch(
                      categoryTag == Category.CGYW ||
                        categoryTag == Category.CGTHYW
                        ? getPurchaseBusinessReviewFn(selectIdTag)
                        : categoryTag == Category.FDTHYW
                        ? getReturnReviewRejectedFn(selectIdTag)
                        : categoryTag == Category.YSYW
                        ? getAcceptanceDetailMainSubmitAsync({id: dataDetail?.id})
                        : getSubmitForReviewFn(selectIdTag)
                    )
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '操作成功',
                        })
                        history.push({
                          pathname: categoryTag == Category.YSYW ? 'acceptanceBusiness' : dataDetail?.type == 2 ? '/procorementBusiness' : '/chainClaimBusiness',
                        })
                      })
                  },
                })
              } else {
                notification.error({
                  message: '未添加药品明细',
                })
              }
            }}
            onPutInto={() => {
              if (categoryTag == Category.CGYW) {
                dispatch(queryInboundDAsync(selectIdTag))
                  .then(unwrapResult)
                  .then((res: any) => {
                    setSearchPage({
                      items: res.records,
                      total: res.total,
                    })
                    setSearchVisible(true)
                  })
              } else {
                if (dataDetail?.providerType == 1) {
                  dispatch(
                    getReturnItemPageFn({
                      ...searchParams,
                      inventoryReceiptsId: selectIdTag,
                    })
                  )
                    .then(unwrapResult)
                    .then((res: any) => {
                      setSearchPage({
                        items: res.records,
                        total: res.total,
                      })
                      setSearchVisible(true)
                    })
                } else {
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认入库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(getReturnDeliveryFn(selectIdTag))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          setSearchVisible(false)
                          history.push({
                            pathname: '/chainClaimBusiness',
                          })
                        })
                    },
                  })
                }
              }
            }}
            onSearch={() => {
              dispatch(
                getReturnItemPageFn({
                  ...searchParams,
                  inventoryReceiptsId: selectIdTag,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  setSearchPage({
                    items: res.records,
                    total: res.total,
                  })
                  setSearchVisible(true)
                })
            }}
            onUpload={() => {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                content: (
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;是否确认上传？
                  </div>
                ),
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onOk: () => {
                  dispatch(
                    categoryTag == Category.CGYW
                      ? getInsertInptPoFn(selectIdTag)
                      : insertInptPktFn(selectIdTag)
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '上传成功',
                      })
                      history.push({
                        pathname: dataDetail?.type == 2 ? '/procorementBusiness' : '/chainTransferOutbound',
                      })
                    })
                },
              })
            }}
            onCopy={() => {
              // 从申领单复制
              if(categoryTag == Category.YSYW) {
                setCopyIsCGYWModalVisible(true)
              } else {
                setCopyIsModalVisible(true)
              }
            }}
            exportExcel={() => {
              exportExcel()
            }}
            exportExcelFB={() => {
              exportExcelFB()
            }}
            onAcceptance={() => {
              setAcceptanceVisible(true)
            }}
            onStorage={() => {
              setStorageVisible(true)
            }}
          />

          <EditableList<DeliveryItem>
            className={styles.table}
            // sticky
            scroll={{
              x: '100rem',
              y: scrollHeight,
            }}
            bordered
            loading={pageLoading}
            columns={
              categoryTag == Category.CGYW
                ? DetailCGColumns(
                    detail?.storehouseId,
                    detail?.storehouseTag,
                    (text, t) => {
                      if (text === 'add') {
                        if (data.every((v: any) => v.id)) {
                          setData([...data, newData])
                        }
                      } else if (text == 'remove') {
                        if (t.id) {
                          dispatch(getStoredetailRemoveFn(t.id))
                            .then(unwrapResult)
                            .then(() => {
                              getData()
                            })
                        } else {
                          setData(data.filter((item: { id: any }) => item.id))
                        }
                      } else if (text === 'edit') {
                        handleChange(t.prev, t.next)
                      } else if (text == 'submit') {
                        const newdata = {
                          ...t.prev,
                          ...t.next,
                        }
                        if (newdata.count &&  (newdata.stockPrice ? newdata.stockPrice :newdata.unitPrice)) {
                          handleSave({
                            ...newdata,
                            deadline: undefined,
                            productDate: undefined,
                            totalPrice: t.next.unitPrice
                              ? t.prev.count * t.next.unitPrice
                              : t.next.count
                              ? t.next.count * t.prev.unitPrice
                              : t.next.count || t.next.unitPrice
                              ? t.next.count * t.next.unitPrice
                              : t.prev.count * t.prev.unitPrice,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                            unitPrice:t.next.unitPrice ? t.next.unitPrice : t.prev.stockPrice? Number(t.prev.stockPrice): Number(t.prev.unitPrice),
                          })
                        } else {
                          const data = [
                            {
                              name: '采购单价',
                              required: true,
                              value: (newdata.stockPrice ? newdata.stockPrice :newdata.unitPrice),
                            },
                            {
                              name: '采购数量',
                              required: true,
                              value: newdata.count,
                            },
                          ]
                          const required = data.filter(
                            (v) => v.required && !v.value
                          )
                          if (required.length) {
                            // setRequiredList(required);
                            messageApi.open({
                              type: 'error',
                              content: '请填写必填项' + required?.[0]?.name,
                              className: 'custom-class',
                            })
                          }
                          handleChange(t.prev, t.next)
                        }
                      } else if (text == 'save') {
                        if (t.count ) {
                          handleSave({
                            ...t,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                          })
                        } else {
                          const data = [
                            {
                              name: '采购数量',
                              required: true,
                              value: t?.count,
                            },
                          ]
                          const required = data.filter(
                            (v) => v.required && !v.value
                          )
                          if (required.length) {
                            // setRequiredList(required);
                            messageApi.open({
                              type: 'error',
                              content: '请填写必填项' + required?.[0]?.name,
                              className: 'custom-class',
                            })
                          }
                        }
                      }
                    }
                  )
                : categoryTag == Category.CGTHYW
                ? DetailCGTHColumns(
                    detail?.storehouseId,
                    detail?.storehouseTag,
                    (text, t) => {
                      if (text === 'add') {
                        if (data.every((v: any) => v.id)) {
                          setData([...data, newData])
                        }
                      } else if (text == 'remove') {
                        if (t.id) {
                          dispatch(getStoredetailRemoveFn(t.id))
                            .then(unwrapResult)
                            .then(() => {
                              getData()
                            })
                        } else {
                          setData(data.filter((item: { id: any }) => item.id))
                        }
                      } else if (text === 'edit') {
                        handleChange(t.prev, t.next)
                      } else if (text == 'submit') {

                        const newdata = {
                          ...t.prev,
                          ...t.next,
                        }
                        if (newdata.count) {
                          handleSave({
                            ...newdata,
                            totalPrice: t.next.unitPrice
                              ? t.prev.count * t.next.unitPrice
                              : t.next.count
                              ? t.next.count * t.prev.unitPrice
                              : t.next.count || t.next.unitPrice
                              ? t.next.count * t.next.unitPrice
                              : t.prev.count * t.prev.unitPrice,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                          })
                        } else {
                          handleChange(t.prev, t.next)
                        }
                      } else if (text == 'save') {
                        if (t.count) {
                          handleSave({
                            ...t,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                          })
                        }
                      }
                    }
                  )
                : categoryTag == Category.FDTHYW ||
                  categoryTag == Category.ZDTHYW
                ? DetailLSTHColumns(
                    detail?.storehouseId,
                    detail?.storehouseTag,
                    location.state?.action || false,
                    (text, t) => {
                      if (text === 'add') {
                        if (data.every((v: any) => v.id)) {
                          setData([...data, newData])
                        }
                      } else if (text == 'remove') {
                        if (t.id) {
                          dispatch(getStoredetailRemoveFn(t.id))
                            .then(unwrapResult)
                            .then(() => {
                              getData()
                            })
                        } else {
                          setData(data.filter((item: { id: any }) => item.id))
                        }
                      } else if (text === 'edit') {
                        handleChange(t.prev, t.next)
                      } else if (text == 'submit') {

                        const newdata = {
                          ...t.prev,
                          ...t.next,
                        }
                        if (newdata.count) {
                          handleSave({
                            ...newdata,
                            totalPrice: t.next.unitPrice
                              ? t.prev.count * t.next.unitPrice
                              : t.next.count
                              ? t.next.count * t.prev.unitPrice
                              : t.next.count || t.next.unitPrice
                              ? t.next.count * t.next.unitPrice
                              : t.prev.count * t.prev.unitPrice,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                            realCount: t.prev.count - t.next.count,
                          })
                        } else {
                          handleChange(t.prev, t.next)
                        }
                      } else if (text == 'save') {
                        if (t.count) {
                          handleSave({
                            ...t,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                          })
                        } else {
                          const data = [
                            {
                              name: '退货数量',
                              required: true,
                              value: t?.count,
                            },
                          ]
                          const required = data.filter(
                            (v) => v.required && !v.value
                          )
                          if (required.length) {
                            // setRequiredList(required);
                            messageApi.open({
                              type: 'error',
                              content: '请填写必填项' + required?.[0]?.name,
                              className: 'custom-class',
                            })
                          }
                        }
                      }
                    }
                  )
                : categoryTag == Category.YSYW ?
                  DetailYSYWColumns(
                    dataDetail?.storehouseId,
                    dataDetail?.approvedState,
                    (text, t) => {
                      if (text === 'add') {
                        if (data.every((v: any) => v.id)) {
                          setData([...data, newData])
                        }
                      } else if (text == 'remove') {
                        if (t.id) {
                          dispatch(getRemoveAcceptanceItemAsync(t.id))
                            .then(unwrapResult)
                            .then(() => {
                              getData()
                            })
                        } else {
                          setData(data.filter((item: { id: any }) => item.id))
                        }
                      } else if (text === 'edit') {
                        handleChange(t.prev, t.next)
                      } else if (text == 'submit') {
                        const newdata = {
                          ...t.prev,
                          ...t.next,
                          productDate: t.next.productDate
                          ? moment(t.next.productDate).format(DateTimeFormat)
                          : moment(t.prev.productDate).format(DateTimeFormat),
                          deadline: t.next.deadline
                          ? moment(t.next.deadline)
                              .endOf('day')
                              .format(DateTimeFormat)
                          : moment(t.prev.deadline)
                              .endOf('day')
                              .format(DateTimeFormat),
                        }
                        const data = [
                          {
                            title: "批号",
                            value: newdata.batchNo,
                            required: true,
                          },
                          {
                            title: "采购单价",
                            value: newdata.arrivalUnitPrice,
                            required: true,
                          },
                          {
                            title: "生产日期",
                            value: newdata.productDate,
                            required: true,
                          },
                          {
                            title: "有效期",
                            value: newdata.deadline,
                            required: true,
                          },
                          {
                            title: "到货数量",
                            value: newdata.totalQuantity,
                            required: true,
                          },
                          {
                            title: "验收合格数量",
                            value: newdata.qualifiedQuantity,
                            required: true,
                          },
                          {
                            title: "验收不合格数量",
                            value: newdata.defectiveQuantity,
                            required: true,
                          },
                          {
                            title: "质量状况",
                            value: newdata.qualityStatus,
                            required: true,
                          },
                          {
                            title: "验收结论",
                            value: newdata.acceptanceConclusion,
                            required: true,
                          },
                        ]
                        const required = data.filter(
                          (v) => v.required && !v.value && v.value !== 0
                        )
                        if (required.length) {
                          messageApi.open({
                            type: 'error',
                            content: '请填写必填项' + required?.[0]?.title,
                            className: 'custom-class',
                          })
                          handleChange(t.prev, t.next)
                        } else {
                          handleChange(t.prev, t.next)
                          handleSubmit({
                            ...newdata,
                          })
                        }
                      } else if (text == 'save') {
                        const newdata = {
                          ...t,
                          productDate: moment(t.productDate).format(
                            DateTimeFormat
                          ),
                          deadline: moment(t.deadline)
                            .endOf('day')
                            .endOf('day')
                            .format(DateTimeFormat),
                        }
                        const data = [
                          {
                            title: "批号",
                            value: newdata.batchNo,
                            required: true,
                          },
                          {
                            title: "采购单价",
                            value: newdata.arrivalUnitPrice,
                            required: true,
                          },
                          {
                            title: "生产日期",
                            value: newdata.productDate,
                            required: true,
                          },
                          {
                            title: "有效期",
                            value: newdata.deadline,
                            required: true,
                          },
                          {
                            title: "到货数量",
                            value: newdata.totalQuantity,
                            required: true,
                          },
                          {
                            title: "验收合格数量",
                            value: newdata.qualifiedQuantity,
                            required: true,
                          },
                          {
                            title: "验收不合格数量",
                            value: newdata.defectiveQuantity,
                            required: true,
                          },
                          {
                            title: "质量状况",
                            value: newdata.qualityStatus,
                            required: true,
                          },
                          {
                            title: "验收结论",
                            value: newdata.acceptanceConclusion,
                            required: true,
                          },
                        ]
                        const required = data.filter(
                          (v) => v.required && !v.value && v.value !== 0
                        )
                        if (required.length) {
                          messageApi.open({
                            type: 'error',
                            content: '请填写必填项' + required?.[0]?.title,
                            className: 'custom-class',
                          })
                        } else {
                          handleSubmit({
                            ...newdata,
                          })
                        }
                      }
                    }
                  )
                : DetailSLColumns(
                    detail?.storehouseId,
                    detail?.storehouseTag,
                    (text, t) => {
                      if (text === 'add') {
                        if (data.every((v: any) => v.id)) {
                          setData([...data, newData])
                        }
                      } else if (text == 'remove') {
                        if (t.id) {
                          // setDeleteSubmitTag(t);
                          dispatch(getStoredetailRemoveFn(t.id))
                            .then(unwrapResult)
                            .then(() => {
                              getData()
                            })
                        } else {
                          setData(data.filter((item: { id: any }) => item.id))
                        }
                      } else if (text === 'select') {
                        setPiCiVisible(true)
                        setActionType('select')
                        setPiCiData(t)
                      } else if (text === 'detail') {
                        setPiCiVisible(true)
                        setActionType('detail')
                        setPiCiData(t)
                      } else if (text === 'edit') {
                        handleChange(t.prev, t.next)
                      } else if (text == 'submit') {
                        const newdata = {
                          ...t.prev,
                          ...t.next,
                          deadline: undefined,
                          productDate: undefined,
                          // totalPrice: t.next.unitPrice
                          //   ? t.prev.count * t.next.unitPrice
                          //   : t.next.count
                          //   ? t.next.count * t.prev.unitPrice
                          //   : t.prev.count * t.prev.unitPrice,
                        }
                        if (newdata.count) {
                          handleSave({
                            ...newdata,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                          })
                        } else {
                          handleChange(t.prev, t.next)
                        }
                      } else if (text == 'save') {
                        if (t.count) {
                          handleSave({
                            ...t,
                            tempName: t.name,
                            category: categoryTag,
                            tenantInventoryReceiptsId: selectIdTag,
                          })
                        } else {
                          const data = [
                            // {
                            //   name: "进价",
                            //   required: true,
                            //   value: t?.unitPrice,
                            // },
                            {
                              name: '申领数量',
                              required: true,
                              value: t?.count,
                            },
                          ]
                          const required = data.filter(
                            (v) => v.required && !v.value
                          )
                          if (required.length) {
                            // setRequiredList(required);
                            messageApi.open({
                              type: 'error',
                              content: '请填写必填项' + required?.[0]?.name,
                              className: 'custom-class',
                            })
                          }
                        }
                      }
                    },
                    detail?.supplierName,
                  )
            }
            rowClassName={() => 'editable-row'}
            rowKey={(t: any) => t.id}
            dataSource={categoryTag == Category.YSYW ? data?.map((v: any) => {
              return {
                ...v,
                productDate: v?.productDate
                  ? moment(v?.productDate).format(DateTimeFormatSimple)
                  : undefined,
                deadline: v?.deadline
                  ? moment(v?.deadline).format(DateTimeFormatSimple)
                  : undefined,
              }
            }) :data}
          />
        </div>
        <Form
          form={form}
          onFinish={(vs) => {
            if(categoryTag == Category.YSYW) {
              dispatch(
                getAcceptanceDetailMainRemarkSubmitAsync({
                  ...vs,
                  id: dataDetail?.id
                })
              ).then(() => getData())
            } else {
              dispatch(
              updataPutstorage2({
                ...detail,
                ...vs,
              })
            ).then(() => getData()) //获取详情
            }
          }}
        >
          {categoryTag == Category.CGYW ||
          categoryTag == Category.CGTHYW ||
          categoryTag == Category.FDTHYW ||
          categoryTag == Category.ZDTHYW ? (
            <Row className={styles.footer}>
              <Col span={4}>
                {categoryTag == Category.CGYW ? '采购金额：' : '退货金额：'}
                {categoryTag == Category.ZDTHYW ||
                categoryTag == Category.CGYW ||
                categoryTag == Category.CGTHYW
                  ? dataDetail?.submittedTotalAmount > 0
                    ? dataDetail?.submittedTotalAmount
                    : 0.00
                  : dataDetail?.actualTotalAmount > 0
                  ? dataDetail?.actualTotalAmount
                  : 0.00}
              </Col>
              {dataDetail?.storehouseTag == '208' ||
                (dataDetail?.storehouseTag == '202' && (
                  <Col span={20} style={{ color: '#FF1B1B' }}>
                    不通过原因：{dataDetail?.remark?.split('$@$')?.[1]}
                  </Col>
                ))}
              {dataDetail?.storehouseTag == '206' ||
              dataDetail?.storehouseTag == '200' ? (
                <Col span={24} style={{ marginTop: '15px' }}>
                  <Form.Item
                    label='单据备注'
                    name='remark'
                    rules={[{ max: 256, message: '最大256位!' }]}
                  >
                    <TextArea
                      // disabled={detail?.storehouseTag == "206" ? false : true}
                      onBlur={(e) => {
                        form.submit()
                      }}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <>
                  <Col span={24} style={{ marginTop: '15px' }}>
                    单据备注：{dataDetail?.remark?.split('$@$')?.[0]}
                  </Col>
                  <Col span={24} style={{ height: 40 }}></Col>
                </>
              )}
            </Row>
          ) : categoryTag == Category.YSYW ? (
            <Row className={styles.footer}>
              <Col span={4}>
                验收品种: {dataDetail?.arrivalCategoryCount >= 0 ? dataDetail?.arrivalCategoryCount : 0}
              </Col>
              {dataDetail?.approvedState == 3 && (
                  <Col span={20} style={{ color: '#FF1B1B' }}>
                    不通过原因：{dataDetail?.remark?.split('$@$')?.[1]}
                  </Col>
                )}
              {dataDetail?.approvedState == 0 ? (
                <Col span={24} style={{ marginTop: '15px' }}>
                  <Form.Item
                    label='单据备注'
                    name='remark'
                    rules={[{ max: 256, message: '最大256位!' }]}
                  >
                    <TextArea
                      // disabled={detail?.storehouseTag == "206" ? false : true}
                      onBlur={(e) => {
                        form.submit()
                      }}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <>
                  <Col span={24} style={{ marginTop: '15px' }}>
                    单据备注：{dataDetail?.remark?.split('$@$')?.[0]}
                  </Col>
                  <Col span={24} style={{ height: 40 }}></Col>
                </>
              )}
            </Row>
          ) : (
            <Row className={styles.footer}>
              {dataDetail?.storehouseTag != '202' &&
              dataDetail?.storehouseTag != '200' ? (
                <>
                  {/* <Col span={4}>申领金额：{dataDetail?.submittedTotalAmount}</Col> */}
                  <Col span={20}>
                    实际调拨金额：
                    {dataDetail?.actualTotalAmount > 0
                      ? (dataDetail?.actualTotalAmount)?.toFixed(2)
                      : ''}
                  </Col>
                  <Col span={24} style={{ marginTop: '15px' }}>
                    单据备注：{dataDetail?.remark?.split('$@$')?.[0]}
                  </Col>
                  <Col span={24} style={{ height: 40 }}></Col>
                </>
              ) : (
                <>
                  {/* <Col span={4}>申请调拨金额：</Col> */}
                  {dataDetail?.storehouseTag != '200' && (
                    <Col span={20} style={{ color: '#FF1B1B' }}>
                      不通过原因：{dataDetail?.remark?.split('$@$')?.[1]}
                    </Col>
                  )}
                  {dataDetail?.storehouseTag == '200' ? (
                    <Col span={24} style={{ marginTop: '15px' }}>
                      <Form.Item
                        label='单据备注'
                        name='remark'
                        rules={[{ max: 256, message: '最大256位!' }]}
                      >
                        <TextArea
                          disabled={detail?.storehouseTag == 200 ? false : true}
                          onBlur={(e) => {
                            form.submit()
                          }}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <>
                      <Col span={24} style={{ marginTop: '15px' }}>
                        单据备注：{dataDetail?.remark?.split('$@$')?.[0]}
                      </Col>
                      <Col span={24} style={{ height: 40 }}></Col>
                    </>
                  )}
                </>
              )}
            </Row>
          )}
        </Form>
      </div>

      <Modal
        title={actionType == 'detail' ? '批次查看' : '批次选择'}
        visible={piCiVisible}
        centered
        width={'60%'}
        onCancel={() => {
          setPiCiVisible(false)
        }}
        onOk={() => {
          setPiCiVisible(false)
        }}
        destroyOnClose
        footer={null}
      >
        <Row style={{ marginBottom: 20 }}>
          <Col span={8}>药品名称：{piCiData?.name}</Col>
          <Col span={8}>申领数量：{piCiData?.needCount}</Col>
        </Row>
        <EditableList
          className={styles.table}
          bordered
          scroll={{
            x: '20rem',
            y: scrollHeight,
          }}
          loading={pageLoading}
          columns={PiCiColumns(actionType, detail?.storehouseTag, (text, t) => {
            let newData: any = {}

            if (
              Number(t.next.count) > Number(t.prev.count) &&
              Number(totalCount) + Number(t.next.count) - Number(t.prev.count) >
                Number(piCiData?.needCount)
            ) {
              newData = { ...t.prev }
              notification.error({
                message: '调拨数量不能大于申请数量',
              })
            } else {
              newData = { ...t.prev, ...t.next }
            }
            setPiCiData({
              ...piCiData,
              batchs: piCiData?.batchs?.map((v: any) =>
                v.subInventoryLedgerId === newData.subInventoryLedgerId
                  ? newData
                  : { ...v }
              ),
            })
            // setTotalCount(
            //   Number(totalCount) - Number(t.prev.count) + Number(t.next.count)
            // );
          })}
          rowKey={(t: any) => t.id}
          dataSource={piCiData?.batchs || []}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell className={styles.footingTitle} index={0}>
                  合计
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
                <Table.Summary.Cell index={4}></Table.Summary.Cell>
                <Table.Summary.Cell index={5}></Table.Summary.Cell>
                {tenantId == chainId && detail?.storehouseTag == 201 && (
                  <Table.Summary.Cell index={6}></Table.Summary.Cell>
                )}
                <Table.Summary.Cell index={7} align='center'>
                  {totalCount}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
        {actionType == 'select' && (
          <Row justify='end' style={{ marginTop: 20 }}>
            <Space>
              <Button
                onClick={() => {
                  setPiCiVisible(false)
                }}
              >
                取消
              </Button>
              <Button
                type='primary'
                onClick={() => {
                  setData(
                    data?.map((v: any) => {
                      return v.applyItemId == piCiData.applyItemId
                        ? {
                            ...piCiData,
                            stockCount: totalCount,
                            stockPrice:
                              totalCount * piCiData?.batchs?.[0]?.costPrice,
                          }
                        : v
                    })
                  )
                  setPiCiVisible(false)
                }}
              >
                确认
              </Button>
            </Space>
          </Row>
        )}
      </Modal>

      <Modal
        title={'审核不通过'}
        visible={refuseVisible}
        centered
        width={600}
        onCancel={() => {
          setRefuseVisible(false)
          formRefuse.resetFields
        }}
        onOk={() => {
          formRefuse.submit()
        }}
        destroyOnClose
      >
        <Form
          form={formRefuse}
          onFinish={(vs) => {
            dispatch(
              categoryTag == Category.CGYW || categoryTag == Category.CGTHYW
                ? getPurchaseBusinessRejectedFn({
                    subInventoryReceiptsId: selectIdTag,
                    ...vs,
                  })
                : categoryTag == Category.ZDTHYW
                ? getReturnRejectedFn({
                    subInventoryReceiptsId: selectIdTag,
                    ...vs,
                  })
                : categoryTag == Category.YSYW
                ? getAcceptanceApproveAsync({
                  ...vs,
                  id: dataDetail?.id,
                  type: 2,
                  arrivalOrderNumber: dataDetail?.arrivalOrderNumber,
                  supplierId: dataDetail?.supplierId,
                  supplierName: dataDetail?.supplierName,
                })
                : getReviewRejectedFn({
                    subInventoryReceiptsId: selectIdTag,
                    ...vs,
                  })
            )
              .then(unwrapResult)
              .then(() => {
                message.success('操作成功')
                formRefuse.resetFields()
                setRefuseVisible(false)
                history.push({
                  pathname: categoryTag == Category.YSYW ? '/acceptanceBusiness' : dataDetail?.type == 2 ? '/procorementBusiness' : '/chainTransferOutbound',
                })
              })
          }}
        >
          <Form.Item
            label='不通过原因'
            name='rejectReason'
            rules={[{ required: true, message: '请输入原因' }]}
          >
            <TextArea rows={4} placeholder='请输入' />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={'入库结果查询'}
        visible={searchVisible}
        centered
        width={'80%'}
        footer={null}
        destroyOnClose
        onCancel={() => {
          setSearchVisible(false)
        }}
      >
        <EditableList
          style={{ flex: 1 }}
          scroll={{ x: '30rem' }}
          // loading={pageSearchLoading}
          page={{
            items: searchPage.items,
            current: searchParams.current,
            size: searchParams.size,
            total: searchPage.total,
          }}
          pageSizeOptions={['10', '20', '50', '100']}
          rowKey={(m: any) => m.id}
          columns={SearchColumns(categoryTag)}
          onChangePage={(current, size) =>
            setSearchParams({ ...searchParams, current, size: size || 10 })
          }
          sticky
        />
        {detail?.storehouseTag == '204' ||
          (detail?.storehouseTag == '210' && (
            <Row justify='end' style={{ marginTop: '20px' }}>
              <Space>
                <Button onClick={() => setSearchVisible(false)}>取消</Button>
                <Button
                  type='primary'
                  onClick={() => {
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认入库？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(
                          categoryTag == Category.CGYW
                            ? queryInboundOperateInventoryFn(selectIdTag)
                            : getReturnDeliveryFn(props?.selectId)
                        )
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '操作成功',
                            })
                            setSearchVisible(false)
                            history.push({
                              pathname: dataDetail?.type == 2 ? '/procorementBusiness' : '/chainClaimBusiness',
                            })
                          })
                      },
                    })
                  }}
                >
                  确认入库
                </Button>
              </Space>
            </Row>
          ))}
      </Modal>
      <CopyModal
        targetInventoryReceiptsId={
          tenantId == chainId ? Number(selectIdTag) : dataDetail?.acceptId
        }
        detail={detail}
        storehouseTag={detail?.storehouseTag}
        visible={copyIsModalVisible}
        onOk={() => {
          setCopyIsModalVisible(false)
        }}
        onCancel={() => {
          setCopyIsModalVisible(false)
        }}
        refresh={() => {
          setCopyIsModalVisible(false)
          getData()
        }}
      ></CopyModal>

      <CopyCGYWModal
        targetInventoryReceiptsId={
          tenantId == chainId ? Number(selectIdTag) : dataDetail?.acceptId
        }
        detail={dataDetail}
        visible={copyIsCGYWModalVisible}
        onOk={() => {
          setCopyIsCGYWModalVisible(false)
        }}
        onCancel={() => {
          setCopyIsCGYWModalVisible(false)
        }}
        refresh={() => {
          setCopyIsCGYWModalVisible(false)
          getData()
        }}
      ></CopyCGYWModal>

      <AcceptanceModal
        data={dataDetail}
        category={categoryTag}
        visible={acceptanceVisible}
        onCancel={() => setAcceptanceVisible(false)}
        onOk={() => {
          setAcceptanceVisible(false)
          history.push({
            pathname: dataDetail?.type == 2 ? '/procorementBusiness' : '/chainClaimBusiness',
          })
        }}
      />

      <StorageModal
        data={dataDetail}
        category={categoryTag}
        visible={storageVisible}
        onCancel={() => setStorageVisible(false)}
        onOk={() => {
          setStorageVisible(false)
          history.push({
            pathname:  dataDetail?.type == 2 ? '/procorementBusiness' : '/chainClaimBusiness',
          })
        }}
      />

      <PrintTemplateModal
        templateCategory={PrintTemplateCategory.SXD}
        visible={isPrintModalVisible}
        tenantInventoryReceiptsId={selectIdTag}
        onCancel={() => setIsPrintModalVisible(false)}
      />
    </>
  )
}
